// I/O client pour la connexion Microsoft Outlook (EPIC Outlook PR1).
import { supabase } from '../../lib/supabaseClient';

export interface OutlookConnection {
  id: string;
  ms_email: string;
  status: 'active' | 'revoked' | 'pending' | string;
  connected_at: string | null;
  last_sync_at: string | null;
  last_error: string | null;
  created_at: string;
}

/** Connexion de l'avocat courant (RLS : ne voit que la sienne). null si aucune. */
export async function getMyOutlookConnection(
  collaboratorId: string,
): Promise<OutlookConnection | null> {
  const { data, error } = await supabase
    .from('outlook_connections')
    .select('id, ms_email, status, connected_at, last_sync_at, last_error, created_at')
    .eq('collaborator_id', collaboratorId)
    .maybeSingle();
  if (error) throw new Error(`Failed to load Outlook connection: ${error.message}`);
  return (data as OutlookConnection | null) ?? null;
}

/** Démarre l'OAuth Microsoft : récupère l'URL et redirige. */
export async function startOutlookConnect(): Promise<void> {
  const { data, error } = await supabase.functions.invoke('outlook-oauth-start', {
    method: 'POST',
  });
  if (error) throw new Error(`OAuth start failed: ${error.message}`);
  const url = (data as { url?: string })?.url;
  if (!url) throw new Error('OAuth start: no URL returned');
  window.location.href = url;
}

/** Déconnecte Outlook (revoke + purge). */
export async function disconnectOutlook(): Promise<void> {
  const { error } = await supabase.functions.invoke('outlook-oauth-disconnect', {
    method: 'POST',
  });
  if (error) throw new Error(`Disconnect failed: ${error.message}`);
}

export interface OutlookQueueItem {
  id: string;
  from_email: string;
  from_name: string | null;
  subject: string | null;
  internal_date: string;
  status: 'queued' | 'unmatched';
  candidate_dossier_ids: string[] | null;
}

/** Messages Outlook en attente de tri manuel (RLS filtre déjà par connexion de l'utilisateur). */
export async function fetchOutlookQueue(): Promise<OutlookQueueItem[]> {
  const { data, error } = await supabase
    .from('outlook_processed_messages')
    .select('id, from_email, from_name, subject, internal_date, status, candidate_dossier_ids')
    .in('status', ['queued', 'unmatched'])
    .order('internal_date', { ascending: false });
  if (error) throw error;
  return (data ?? []) as OutlookQueueItem[];
}

/** Rattache un message à un dossier via l'Edge Function (import PJ + status=imported). */
export async function assignOutlookMessage(processedMessageId: string, dossierId: string): Promise<void> {
  const { error } = await supabase.functions.invoke('outlook-assign-message', {
    body: { processed_message_id: processedMessageId, dossier_id: dossierId },
  });
  if (error) throw error;
}
